import { QueryClient } from "@tanstack/react-query";
import { getParamsFromType } from "~/participant/views/AssignmentsListView.helpers";
import { ASSIGNMENTS_QUERIES } from "~/shared/api/assignments/assignments.queries";

export function assignmentsListViewLoader(queryClient: QueryClient, type?: "pending" | "submitted") {
  const params = getParamsFromType(type);

  queryClient.prefetchQuery(
    ASSIGNMENTS_QUERIES.user.list({
      params: {
        ...params,
        limit: 50,
        skip: 0,
      },
    }),
  );

  return null;
}
